import Box from "@material-ui/core/esm/Box";
import Chip from "@material-ui/core/esm/Chip";
import Paper from "@material-ui/core/esm/Paper";
import NavigateNext from "@material-ui/icons/esm/NavigateNext";
import Star from "@material-ui/icons/esm/Star";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { SecondaryButton } from 'components/Button';
import InfoBox from 'components/InfoBox/InfoBox';
import StatusBullet from 'components/StatusBullet/StatusBullet';
import { Info, Title } from 'components/Text';
import VehicleIcon from 'components/VehicleIcon/VehicleIcon';
import EnumObeStatus from 'constants/obeStatuses';
import { TAG_DETAILS } from 'routes/overview/paths';
import dateTimeFormatter from 'utils/date/dateTimeFormatter';
import { getSubscriptionPlanName, SubscriptionPlan } from 'utils/mapping/mapSubscriptionPlan';
import getObeStatusBullet from 'utils/obes/getObeStatusBullet';
import useStyles from './VehicleCardStyles';
export default function VehicleCard({
  obeNumber = '',
  obeStatus,
  vehicle,
  replacedBy,
  replacementCompleted,
  updatedOn,
  subscriptionPlanId,
  pendingSubscriptionChange
}) {
  const {
    t
  } = useTranslation();
  const {
    vehicleRoot,
    information,
    spacingLeft,
    buttonGroup,
    subscriptionBadgeBasic,
    subscriptionBadgeStandard,
    headerRow,
    leftAlignedBox
  } = useStyles();
  const {
    push
  } = useHistory();
  const updatedObeStatus = replacedBy && !replacementCompleted ? EnumObeStatus.BeingReplaced : obeStatus;

  // Only show subscription badge for Active, Inactive, or Frozen OBEs
  const shouldShowSubscriptionBadge = updatedObeStatus ? [EnumObeStatus.Active, EnumObeStatus.Inactive, EnumObeStatus.Frozen].includes(updatedObeStatus) : false;
  const subscriptionPlanName = subscriptionPlanId ? getSubscriptionPlanName(subscriptionPlanId) : null;
  const renderSubscriptionBadge = () => {
    if (!shouldShowSubscriptionBadge || !subscriptionPlanName) return null;
    const isStandard = subscriptionPlanName === SubscriptionPlan.Standard;
    return /*#__PURE__*/React.createElement(Chip, {
      label: t(`subscriptions.plans.${subscriptionPlanName.toLowerCase()}`),
      size: "small",
      className: isStandard ? subscriptionBadgeStandard : subscriptionBadgeBasic,
      icon: isStandard ? /*#__PURE__*/React.createElement(Star, null) : undefined
    });
  };
  return /*#__PURE__*/React.createElement(Paper, {
    className: vehicleRoot,
    elevation: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: information
  }, /*#__PURE__*/React.createElement(VehicleIcon, {
    vehicle: vehicle
  }), /*#__PURE__*/React.createElement("div", {
    className: spacingLeft
  }, /*#__PURE__*/React.createElement("div", {
    className: headerRow
  }, /*#__PURE__*/React.createElement(Title, {
    isBold: true,
    hasNoSpacing: true
  }, vehicle?.registrationNumber || t('vehicles.no_attached_vehicle')), renderSubscriptionBadge()), /*#__PURE__*/React.createElement(Info, null, `${t('tag.tag_number')}: ${obeNumber}`), /*#__PURE__*/React.createElement(Info, {
    align: "left"
  }, updatedObeStatus && /*#__PURE__*/React.createElement(StatusBullet, {
    status: getObeStatusBullet[updatedObeStatus],
    text: t(`status.${updatedObeStatus.toLowerCase()}`, {
      replacedBy
    })
  })))), updatedObeStatus === EnumObeStatus.BeingReplaced && /*#__PURE__*/React.createElement(Box, {
    mt: 2
  }, /*#__PURE__*/React.createElement(InfoBox, {
    warning: true
  }, t('error.replaced', {
    replacementDate: dateTimeFormatter(updatedOn)
  }))), pendingSubscriptionChange && pendingSubscriptionChange.effectiveDate && /*#__PURE__*/React.createElement(Box, {
    mt: 2,
    className: leftAlignedBox
  }, /*#__PURE__*/React.createElement(InfoBox, null, t('subscriptions.changing_to_on_date', {
    newPlan: pendingSubscriptionChange.newSubscriptionPlanId ? t(`subscriptions.plans.${getSubscriptionPlanName(pendingSubscriptionChange.newSubscriptionPlanId)?.toLowerCase()}`) : '',
    effectiveDate: dateTimeFormatter(pendingSubscriptionChange.effectiveDate)
  }) || '')), obeNumber && /*#__PURE__*/React.createElement("div", {
    className: buttonGroup
  }, /*#__PURE__*/React.createElement(SecondaryButton, {
    onClick: () => push(TAG_DETAILS(obeNumber)),
    endIcon: /*#__PURE__*/React.createElement(NavigateNext, null)
  }, t('buttons.see_details'))));
}